import { useMemo } from "react";

import { useWorkspaceContext } from "src/router/routerContextHooks";

// Fallback for workspaces whose case_management spec predates the config key. Kept in
// sync with MAX_TEMPLATES_LIMIT in the case_management module.
export const DEFAULT_MAX_CASE_TEMPLATES = 10;

export const useMaxCaseTemplates = (): number => {
  const { modules } = useWorkspaceContext();

  return useMemo(() => {
    const spec = modules?.find((m) => m.kind === "case_management")?.spec;
    const limit = spec?.config.max_templates_limit;

    return typeof limit === "number" && limit > 0
      ? limit
      : DEFAULT_MAX_CASE_TEMPLATES;
  }, [modules]);
};
